import {cs} from "@common/react/chain-services";
import "./skeleton-box.scss";

export const SkeletonBox = ({style = {}}) => cs(() => <div className="skeleton-box-99o" style={style} />);
